export const textStyles = theme => ({
  fontSize: theme.fontSizes[3],
  lineHeight: 1.7,
  marginBottom: theme.space[12],
  maxWidth: 680,
})
